/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Texture, utils } from 'pixi.js-legacy';
import { FancySprite } from '../../canvas-common/graphics/FancySprite';
import { SwimlaneContainer } from './SwimlaneContainer';
import { Swimlane } from 'src/app/app-data/models/Swimlane';
import { SWIMLANE_GRAPHICS } from './SwimlaneConst';
import { rgbaToNumber } from 'utils/color-utils';
import { EventBinder } from '../interaction/interaction-utils';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
// import { DefaultActionTypes } from "src/app/app-data/state/Swimlanes"
// import {filter} from "rxjs/operators";
/**
 * The SwimlaneArea is the main background area for a swimlane.
 */
export class SwimlaneArea extends FancySprite {
	public override visible = true;
	private _lastColor: string;
	private _binder = new EventBinder(this, 'hammer-panstart', 'hammer-panend');
	constructor(
		swimlaneModel: Swimlane,
		private canvasAngularLand: CanvasAngularLand,
		texture: Texture = utils.TextureCache[SWIMLANE_GRAPHICS.SWIMLANE_AREA]
	) {
		super(texture);

		// TODO: Parse the 'a' value from a rgba string and use that.
		this.alpha = 0.1;

		this._binder.add('hammer-panstart', (event) => {
			(this.parent as SwimlaneContainer).lineContainer.cutInLine();
			const cleanedMap = new Map();
			this.canvasAngularLand.swimlanes.data.editList$
				.getValue()
				.forEach((s, id) => cleanedMap.set(id, s.swimlane));
			return this.canvasAngularLand.swimlaneDragService.dragStart(event.center, cleanedMap);
		});
		this._binder.add('hammer-pan', (event) => {
			return this.canvasAngularLand.swimlaneDragService.drag(event.center);
		});
		this._binder.add('hammer-panend', (event) => {
			return this.canvasAngularLand.swimlaneDragService.dragEnd(event.center);
		});
	}

	public setColor(color: string) {
		if (color !== this._lastColor) {
			this.tint = rgbaToNumber(color);
			this._lastColor = color;
		}
	}

	public override destroy() {
		this._binder.destroy();
	}
}
